<template>
  <div class="columns is-multiline">
    <section class="info-tiles column is-12">
      <div class="card">
        <div class="card-header">
          <a @click="goTo('account')" class="button is-light is-radiusless">&lt; Regresar</a>
          <a @click="toggleInstructions()" class="button is-dark is-radiusless">Ayuda</a>
        </div>
        <form class="has-text-left">
          <div class="card-content">
            <h3 class="is-size-3">{{initTitle}}</h3>
            <br>
            <div class="columns is-multiline">
              <b-field label="Cuenta*" class="column is-6">
                <b-input v-model="account.account"></b-input>
              </b-field>
              <b-field class="column is-6" label="Municipio">
                <b-select v-model="account.municipality" class="mb-3">
                    <option :value="null" disabled>-- Please select an option --</option>
                    <option value="CALI">Cali</option><option value="JAMUNDI">Jamundi</option><option value="YUMBO">Yumbo</option>
                </b-select>
              </b-field>
              <b-field class="column is-12" label="Descripción*">
                <b-input v-model="account.description" type="textarea"></b-input>
              </b-field>
            </div>
          </div>
          <div class="card-footer">
            <button type="button" class="button is-warning is-radiusless" @click="submit()">Enviar</button>
            <button type="button" class="button is-default is-radiusless" @click="goTo('account')">Cancelar</button>
          </div>
        </form>
      </div>
    </section>
    <!-- help -->
    <section v-if="needHelp" class="info-tiles column is-12">
      <div class="card">
        <div class="card-header">
          <a @click="toggleInstructions()" class="button is-light is-radiusless">X Cerrar ayuda</a>
        </div>
        <div class="card-content">
          <h3 class="is-size-3">Ayuda</h3>
          <h3 class="is-size-4">Instrucciones</h3>
          <ul>
              <li>- Campos con (*) son requeridos</li>
            </ul>
        </div>
      </div>
    </section>
  </div>
</template>
<script>
import VueCkeditor from 'vue-ckeditor2'
import AccountsService from '@/services/AccountsService'
import { xMisc } from '@/mixins/xMisc.js'
import { sGate } from '@/mixins/sGate.js'
export default {
  name: 'dashboard',
  mixins: [xMisc, sGate],
  components: {
    VueCkeditor
  },
  data () {
    return {
      mode: (this.$route.params.id) ? 'edit' : 'create',
      account: {
        account: null,
        description: null,
        municipality: null
      },
      needHelp: false,
      helpText: 'Ayuda',
      initTitle: 'Añadir nueva cuenta'
    }
  },
  mounted () {
    if (this.mode === 'edit') {
      this.initTitle = 'Editar cuenta'
      this.getData()
    }
  },
  methods: {
    async submit () {
      if (this.account.account == null) {
        this.alert('danger', 'Cuenta es requerida')
        return false
      }
      if (this.account.description == null) {
        this.alert('danger', 'Descripcion es requerida')
        return false
      }
      var response = {}
      // POST
      if (this.mode === 'create') {
        response = await AccountsService.addAccount({data: this.account}, this.$session.get('user').token)
      } else if (this.mode === 'edit') {
        response = await AccountsService.editAccount({id: this.$route.params.id, data: this.account}, this.$session.get('user').token)
      }
      if (response.data.success) {
        if (this.mode === 'edit') {
          this.$toast.open({
            message: 'Cuenta actualizada',
            type: 'is-success'
          })
        } else {
          this.$toast.open({
            message: 'Cuenta creada',
            type: 'is-success'
          })
        }
        this.goTo('account')
      } else {
        this.alert('danger', 'Error, no se pudo crear la cuenta')
      }
    },
    async getData () {
      var response = await AccountsService.getAccount({id: this.$route.params.id}, this.$session.get('user').token)
      this.account.account = response.data.account
      this.account.municipality = response.data.municipality
      this.account.description = response.data.description
    },
    toggleInstructions () {
      if (this.needHelp) {
        this.needHelp = false
        this.helpText = 'Ayuda'
      } else {
        this.needHelp = true
        this.helpText = 'Cerrar ayuda'
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/account/AccountForm.vue